/**
 * 特别注意：安卓环境，存储大数据例如base64信息时，将出现异常，ios正常表现
 * 建议使用globalData，来做大数据存储
 */
import Storage from '@fe/storage'
import { APP_NAME } from '@base/constants'

const storage = new Storage({
  type: 'local',
  prefix: APP_NAME,
})

export default storage
